import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {useImageListContext} from './context';
import styles from './forward-button.module.css';

export function ImageListForwardButton() {
  const {currentSlidePage, setCurrentSlidePage, total} = useImageListContext();

  const onClick = () => {
    setCurrentSlidePage((previous) => {
      const newPage = previous + 1;
      if (total < newPage) return previous;

      return newPage;
    });
  };

  if (currentSlidePage === total) return null;

  return (
    <button
      type='button'
      className={clsx(
        styles.forwardButton,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
      aria-label='次のページへ進む'
      onClick={onClick}
    >
      <svg
        role='img'
        aria-label='右矢印'
        width='18'
        height='20'
        viewBox='0 0 18 20'
        fill='none'
      >
        <g>
          <path
            d='M8.77344 2.73877L15.782 9.78528L8.85188 16.7369'
            stroke='black'
            strokeWidth='2.00343'
            strokeMiterlimit='2'
          />
        </g>
        <g>
          <path
            d='M15.7617 9.73633H1.76182'
            stroke='black'
            strokeWidth='2.00161'
            strokeMiterlimit='1'
          />
        </g>
      </svg>
    </button>
  );
}
